var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CommonService } from "~/utils/common.service";
export default {
    departmentTreeData: function (state) {
        return function (deptType) {
            var departmentList = state.departmentList.filter(function (x) {
                return deptType ? x.deptType === deptType : true;
            }).map(function (v) { return (__assign({}, v)); });
            return CommonService.generateTreeData(departmentList, {
                keyName: 'id',
                parentKeyName: 'parentId'
            });
        };
    },
    departmentTreeDataTwo: function (state) {
        return function (deptType1, deptType2) {
            var departmentList = state.departmentList.filter(function (x) {
                return deptType1 && deptType2 ? (x.deptType === deptType1 || x.deptType === deptType2) : true;
            }).map(function (v) { return (__assign({}, v)); });
            return CommonService.generateTreeData(departmentList, {
                keyName: 'id',
                parentKeyName: 'parentId'
            });
        };
    },
    /**
     * 用户部门数据
     * @param param0
     */
    departmentData: function (state, getters) {
        return getters.departmentTreeData();
    },
    /**
     * 用户部门数据
     * @param param0
     */
    visitDepartmentData: function (state, getters) {
        return getters.departmentTreeData("VISIT");
    },
    /**
     * 电话催收部门数据
     * @param param0
     */
    callDepartmentData: function (state, getters) {
        return getters.departmentTreeData("TEL");
    },
    /**
     * 外访部门数据无root
     * @param param0
     */
    visitDepartmentDataNoRoot: function (state, getters) {
        return getters.departmentTreeData("VISIT");
    },
    /**
     * 法务催收部门数据
     * @param param0
     */
    legalDepartmentData: function (state, getters) {
        return getters.departmentTreeData("LEGAL");
    },
    /**
     * 返回是否超级管理员
     */
    isSupperAdmin: function (state, getters) {
        return state.userData.companyCode === null;
    },
    /**
     * 欺诈部门数据无root
     * @param param0
     */
    cheatDepartmentDataNoRoot: function (state, getters) {
        return getters.departmentTreeData("CHEAT");
    },
    /**
     * 诉讼部门数据无root
     * @param param0
     */
    lawDepartmentDataNoRoot: function (state, getters) {
        return getters.departmentTreeData("LAW");
    },
    /**
     * 外诉部门数据无root
     * @param param0
     */
    OutLawDepartmentDataNoRoot: function (state, getters) {
        return getters.departmentTreeData("OUT_LAW");
    },
    /**
     * 信用修复部门数据 无root
     * @param state
     * @param getters
     */
    creditRepairDepartmentDataNoRoot: function (state, getters) {
        return getters.departmentTreeData("REPAIR");
    },
    getAllParentId: function (state) {
        var findParent = function (id, type) {
            var departmentList = state.departmentList.filter(function (x) {
                return type ? x.deptType === type : true;
            });
            if (!departmentList.length)
                return [id];
            var current = departmentList.find(function (x) { return x.id === id; });
            if (!current)
                return [id];
            var parent = departmentList.find(function (x) { return x.id === current.parentId; });
            if (parent) {
                return findParent(parent.id, type).concat(current.id);
            }
            else {
                return [current.id];
            }
        };
        return findParent;
    },
    /**
     * 根据ID获取deptCode
     * @param state
     */
    getDeptCodeById: function (state) {
        return function (id) {
            var dept = state.departmentList.find(function (x) { return x.id === id; });
            return dept ? dept.deptCode : '';
        };
    },
    /**
     * 获取电催和法务的数据
     * @param param0
     */
    departmentDataTwo: function (state, getters) {
        return getters.departmentTreeDataTwo("TEL", "LEGAL");
    },
};
